import {useState} from 'react';
import classNames from 'classnames';

import routers, {buildPath} from '@/config/routers';
import downCountToast from '@/components/DownCountToast';
import toast, {ToastType} from '@/components/Toast';
import {RadioGroup} from '@/components/Radio';
import Icon from '@/components/Icon';
import {CommentGroundChat} from '@/icons';
import sdk from '@/sdk';
import Button from '@/components/Button';
import Dialog from '@/components/Dialog';
import Avatar from '@/components/Avatar';
import {GroupInfo} from '@/interface';
import mentionCache from '@/utils/document/mentionCache';

import styles from './index.module.scss';
interface ICommentCreateGroupChat {
  type: string;
  visible: boolean;
  groupChatList: GroupInfo[];
  userList: string[];
  callbacks: any;
}
interface IGroupModalProps {
    type: 'list' | 'create';
    list: GroupInfo[] | string[];
    cancelFunc: () => void;
    orFunc?: () => void;
    okFunc: (prop?: any) => void;
}

// 打开如流
function handleClickOpenRuLiu(openRuLiu: any) {
    if (!openRuLiu) {
        return;
    }
    const RuLiuPath = buildPath(routers.RuLiuGroup.path, {RuLiuGroupId: openRuLiu});
    window.open(RuLiuPath, '_self');
}
// 创建成功
function createdSuccessToast(cb: any, content?: string): Promise<boolean> {
    const duration = 5000;

    return new Promise(resolve => {
        let toastObj: any = null;
        function revoke() {
            const openRuLiu = cb();
            resolve(false);
            toastObj && toastObj.remove();
            handleClickOpenRuLiu(openRuLiu);
        }

        toastObj = downCountToast({
            duration: duration,
            content: (
                <span>
                    {content}
                    <a onClick={revoke} style={{marginLeft: 10}}>
                        去群聊中查看
                    </a>
                </span>
            ),
            onClickDownCount: revoke,
            onClose: () => resolve(true),
        });
    });
}

// 确认创建群聊弹窗
export function CommentCreateChat({
    type,
    visible,
    groupChatList,
    userList,
    callbacks,
}: ICommentCreateGroupChat) {
    const isPublicGroupChat = (!!(type && type === 'list'));
    const originGroupIndex: number = 0;
    const [GroupIndex, setGroupIndex] = useState(originGroupIndex);
    function getChatGroupListOptions() {
        const newList: any = [];
        groupChatList.forEach((item, index) => {
            const data: any = {
                value: index,
                label: <div
                    className={styles.groupChat}
                >
                    <div className={styles.groupChatImg}>
                        {
                            item.groupAvatar ? <img src={item.groupAvatar} alt="" />
                                : <Avatar
                                    size="sm"
                                    gid={item.groupId}
                                    defaultText={item.groupName}
                                />
                        }
                    </div>
                    <div className={styles.groupChatText}>
                        <p className={styles.groupChatName}>
                            <span className={styles.groupName}>{item.groupName}</span>
                            <span className={styles.groupChatNum}>({item.groupMembers?.length})</span>
                        </p>
                        <span className={styles.groupChatPerson}>{item.groupMembers?.join('、')}</span>
                    </div>
                </div>,
            };
            newList.push(data);
        });
        return newList;
    }

    // 取消
    function handleCancel() {
        callbacks.cancelFunc();
    }
    // 发送和新建并发送
    function handleConfirm() {
        if (isPublicGroupChat) {
            const changeGroup = groupChatList.find((item: any) => item.groupId === groupChatList[GroupIndex].groupId);
            callbacks.okFunc(changeGroup);
        } else {
            callbacks.okFunc();
        }
    }
    // 新建群聊并发送
    function handleCreateConfirm() {
        callbacks.orFunc();
    }
    function handleChangeSecurityScope(nextValue:number) {
        setGroupIndex(nextValue);
    }

    return (<>
        <Dialog
            className={classNames(styles.commentCreateChat)}
            headline={isPublicGroupChat ? '存在相同成员的群聊，是否继续创建' : '确定新建一个群聊并发送通知？'}
            showCloseX={isPublicGroupChat}
            visible={visible}
            maskCancel={false}
            onCancel={handleCancel}
        >
            <div className={styles.commentCreateChatContent}>
                <div className={styles.Content}>
                    {
                        isPublicGroupChat ? (
                            <div className={styles.chatContent}>
                                <RadioGroup
                                    layout={'vertical'}
                                    value={GroupIndex}
                                    options={getChatGroupListOptions()}
                                    onChange={(nextValue: any) => handleChangeSecurityScope(nextValue)}
                                    className={styles.checkOption}
                                />
                            </div>
                        ) : (
                            <div className={styles.disChatContent}>
                                <Icon className={styles.Icon} svg={CommentGroundChat} />
                                <span className={styles.creatChatName}>
                                    {userList.join('、')}
                                </span>
                                <span className={styles.createChatPerson}>({userList.length})</span>
                            </div>
                        )
                    }
                </div>
                <div className={styles.commentCreateChatFoot}>
                    <Button
                        className="cancelBtn"
                        onClick={isPublicGroupChat ? handleCreateConfirm : handleCancel}
                    >{isPublicGroupChat ? '新建群聊并发送' : '取消'}</Button>
                    <Button
                        className="confirmBtn"
                        onClick={handleConfirm}
                    >{isPublicGroupChat ? '发送' : '新建并发送'}</Button>
                </div>
            </div>
        </Dialog>
    </>);
}


interface IShowToast {
    type: string;
    content: string;
    cb?: ()=>void;
}

interface ICommentChatOptions {
    openGroup?: ()=>void;
    openGroupInfo?: ()=>void;
    enableBindGroup: boolean;
    showGroupModal: (data: IGroupModalProps)=>void;
    hideGroupModal: ()=>void;
    showToast: (data: IShowToast)=>void;
}

export const useCommentCreateChat = (docGuid: string): [any, ICommentChatOptions] => {
    const [type, setType] = useState('');
    const [visible, setVisible] = useState(false);
    const [groupChatList, setGroupChatList] = useState<GroupInfo[]>([]);
    const [userList, setUserList] = useState<string[]>([]);
    const [callbacks, setCallbacks] = useState<any>({});

    function hideGroupModal() {
        setVisible(false);
    }

    function showGroupModal(data: IGroupModalProps) {
        const {type, list, cancelFunc, orFunc, okFunc} = data;
        setType(type);
        if (type === 'list') {
            setGroupChatList(list as GroupInfo[]); // 已有群聊的列表
        } else {
            setUserList(list as string[]); // 新建群成员列表
        }
        setCallbacks({
            cancelFunc,
            orFunc,
            okFunc,
        });

        // 打开方法
        setVisible(true);
    }

    function showToast(data: IShowToast) {
        const {type, content, cb} = data;
        if (type === 'info') {
            createdSuccessToast(cb, content);
        } else if (type === 'fail') {
            toast({
                type: ToastType.Error,
                content,
                duration: 3000,
            });
        }
    }

    function getKsServer(cb: any) {
        return sdk.getKsServer().then(cb);
    }

    const commentChatOptions = {
        enableBindGroup: true, // 群聊关联是否启用
        showGroupModal, // 展示群聊选择或新建群聊弹窗
        hideGroupModal, // 隐藏弹窗
        showToast, // 展示toast
        getReplyBindGroup: (commentGuidList: string[]) => {
            return getKsServer((ks: any) => ks.getReplyBindGroup(docGuid, showToast, commentGuidList));
        },
        getGroupListByUserIdList: (userGuidList: string[]) => {
            return getKsServer((ks: any) => ks.getGroupListByUserIdList(userGuidList, showToast));
        },
        createGroup: (action: 'add' | 'reply' | 'modify', commentGuid: string, userGuidList: string[]) => {
            mentionCache.reset();
            return getKsServer((ks: any) => ks.createGroup(docGuid, action, commentGuid, userGuidList));
        },
        bindingGroup: (action: 'add' | 'reply' | 'modify', commentGuid: string, group: GroupInfo) => {
            mentionCache.reset();
            return getKsServer((ks: any) => ks.bindingGroup(docGuid, action, commentGuid, group));
        },
        unbindingGroup: (groupId: number, commentGuid: string) => {
            return getKsServer((ks: any) => ks.unbindingGroup(docGuid, showToast, groupId, commentGuid));
        },
        isUserInGroup: (groupId: number) => {
            return getKsServer((ks: any) => ks.isUserInGroup(showToast, groupId));
        },
        // 关闭小流量。（和编辑器确认，getUserInBindGroupWhiteList不传的话，就不会显示那个评论绑定了什么群的功能，所以这部分就保留了，直接传true过去）
        getUserInBindGroupWhiteList: () => {
            return Promise.resolve({
                isWhite: true,
            });
        },
    };

    const CommentCreateChatModal = () => {
        return (
            <CommentCreateChat
                type={type}
                visible={visible}
                groupChatList={groupChatList}
                userList={userList}
                callbacks={callbacks}
            />
        );
    };

    return [CommentCreateChatModal, commentChatOptions];
};
